// libraries
import { createActions } from 'redux-actions';

export const { setModal, clearModal } = createActions('SET_MODAL', 'CLEAR_MODAL');
